export interface IPricingElements {
	label: string;
	totalOfferPrice: string | undefined;
	additionalInfo: {
		title?: string;
		details: IListItemProps[][];
	}[];
}

export enum EListBackgroundColor {
	white = 'bg-white',
	'gray-warm' = 'bg-gray-warm',
	'gray-600' = 'bg-gray-600',
}

export type ListBackgroundColor = keyof typeof EListBackgroundColor;

type FontVariants = 'header' | 'title' | 'abstract';

type FontColors = 'title' | 'text' | 'error' | 'lightText' | 'inactiveText' | 'white';
export interface IListItemProps {
	backgroundColor?: ListBackgroundColor;
	columnRow?: boolean;
	discountLabel?: string;
	fieldName?: string;
	fullSpace?: boolean;
	isHighlighted?: boolean;
	isProductPrice?: boolean;
	label?: React.ReactNode;
	labelVariant?: FontVariants;
	valueVariant?: FontVariants;
	narrow?: boolean;
	noBorder?: boolean;
	previousValue?: string;
	singleItem?: boolean;
	subLabel?: React.ReactNode;
	type?: 'item' | 'separator';
	value?: React.ReactNode;
	valueColor?: FontColors;
}

export interface IAdditionalInfoProps {
	title?: string;
	details: IListItemProps[];
}

export interface IProductSummaryProps {
	label: string;
	value?: string | JSX.Element;
	totalOfferPrice?: string;
	additionalInfo?: IAdditionalInfoProps[];
}
